<template>
  <aside :class="{hidePanel: panelClosed}">
    <div class="w" @mouseover="toggleMapFreeze(true)" @mouseleave="toggleMapFreeze(false)">
      <div class="s">
      </div>
      <div class="i">
        <header>
          <h2>News Bites: Latest</h2>
          <div v-gtm-tracker="gtmTypeClose" class="close-btn" @click="hidePanel()">
            <svg-close-icon width="20" height="20"></svg-close-icon>
          </div>
        </header>
        <section>
          <news-bites-item v-for="(nid, k) in visibleNodes"  :key="k" :nid="nid"></news-bites-item>
        </section>
        <footer>
          <server-side-only-link
            v-gtm-tracker="gtmType"
            to="/china-tech-city/news" @click.native="goToNewsHome()">more >>
          </server-side-only-link>
        </footer>
      </div>
    </div>
  </aside>
</template>

<script>
  import NewsBitesItem from 'components/tech-city/widgets/NewsBitesItem.vue'
  import slice from 'lodash/slice'
  import get from 'lodash/get'

  import {
    mapActions,
    mapMutations,
  } from 'vuex'

  import SvgCloseIcon from 'static/svg/icon_close.svg'

  export default {
    name: 'news-bites-panel',
    props: {
      nodes: {
        type: Array,
        required: true,
      },
    },
    components: {
      NewsBitesItem,
      SvgCloseIcon,
    },
    computed: {
      gtmType() {
        return {
          ec: 'Tech City/News Bites Panel',
          ea: 'Tech City/News Bites Panel/Section/Click',
          el: '/china-tech-city/news',
        }
      },
      gtmTypeClose() {
        return {
          ec: 'Tech City/News Bites Panel',
          ea: 'Tech City/News Bites Panel/Close',
        }
      },
      visibleNodes() {
        return slice(get(this, 'nodes', []), 0, this.numOfArticle)
      },
    },
    methods: {
      ...mapActions(['setFreezeMap']),
      ...mapMutations(['setActiveNID']),
      toggleMapFreeze(s) {
        this.setFreezeMap(s)
      },
      hidePanel() {
        this.panelClosed = true
        this.toggleMapFreeze(false)
      },
      goToNewsHome() {
        if(get(this, 'nodes[0]')) this.setActiveNID(this.nodes[0])
      },
    },
    mounted() {
    },
    data() {
      return {
        panelClosed: false,
        numOfArticle: 5,
      }
    },
  }
</script>

<style lang="scss" scoped>
$black-20: rgba(0,0,0,0.2);
aside {
  position: absolute;
  top: rem-calc(110);
  left: rem-calc(30);
  bottom: rem-calc(35);
  transform: translateX(-130%);
  transition: transform 0.3s ease;
  z-index: 10;
  &.active {
    transform: translateX(0%);
  }

  &.hidePanel {
    transform: translateX(-130%);
  }

  @include respond-to("mobile") {
    bottom: rem-calc(-5);
    top: auto;
    height: rem-calc(274px);
    left: rem-calc(18);
    right: rem-calc(10);
    transform: translateY(110%);
    &.active {
      transform: translateY(0%);
    }
    &.hidePanel {
      transform: translateY(110%);
    }
  }
}
.w {
  width: rem-calc(292);
  position: relative;
  margin: 0 auto;
  box-shadow: rem-calc(0 4 8 0) $black-20;
  font-family: $barlow;
  color: $darker-gray-2;
  z-index: 10;
  @include respond-to("mobile") {
    width: 100%;
  }
  &:before {
    background: linear-gradient(45deg, $undercooked-omelette 5px, transparent 0) 0 5px, linear-gradient(-45deg, $undercooked-omelette 5px, transparent 0) 0 5px;
    background-position: -6px 0;
    background-size: 10px 10px;
    content: "";
    display: block;
    height: rem-calc(10);
    width: 100%;
    margin-top: rem-calc(-10);
    z-index: 1;
    position: relative;
  }
  &:after {
    display: block;
    position: absolute;
    height: rem-calc(10);
    width: rem-calc(10);
    background: $undercooked-omelette;
    bottom: 0;
    left: rem-calc(-5);
    content: "";
  }
}
.i {
  background: $undercooked-omelette;
  padding: rem-calc(10 15 15);
  border-radius: rem-calc(0 0 5 0);
  margin-left: 0;
  box-shadow: rem-calc(-4 -4 16 0)  $black-20;

  @include respond-to("mobile") {
    padding-bottom: rem-calc(20);
    padding-top: rem-calc(10);
  }
}
.s {
  position: absolute;
  top: rem-calc(20);
  bottom: 0;
  left: rem-calc(-8);
  width: rem-calc(8);
  background: $omelette-on-the-floor;
  border-radius: rem-calc(0 0 8 8);
  box-shadow: inset rem-calc(-7 0 6 -7) $black-20;
  z-index: 1111;
  &:before {
    background: linear-gradient(45deg, $omelette-on-the-floor 5px, transparent 0) 0 5px, linear-gradient(-45deg, $omelette-on-the-floor 5px, transparent 0) 0 5px;
    background-position: -6px 0;
    background-size: 10px 10px;
    box-shadow: inset rem-calc(-7 0 6 -7) $black-20;
    content: "";
    display: block;
    height: rem-calc(10);
    width: 100%;
    margin-top: rem-calc(-10);
    left: rem-calc(-8);
  }
}
header {
  padding: rem-calc(0 5 2);
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-bottom: 1px solid $darker-gray-2;
  @include respond-to("mobile") {
    padding-bottom: rem-calc(4);
  }
  h2 {
    font-size: rem-calc(16);
    font-weight: bold;
    margin: 0;
    color: $darker-gray-2;
    text-transform: uppercase;

    @include respond-to("mobile") {
      font-size: rem-calc(18);
    }
  }
}
footer {
  a {
    background: $dirty-yellow;
    display: block;
    text-align: center;
    font-size: rem-calc(16);
    font-weight: 500;
    padding: rem-calc(4 0 5);
    color: $darker-gray-2;
    text-decoration: none;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.7;
    }
  }
}
section {
  max-height: calc(100vh - 250px);
  overflow: auto;
  @include respond-to("mobile") {
    max-height: rem-calc(175);
  }
}
.close-btn {
  padding: rem-calc(11);
  border-radius: 50%;
  height: rem-calc(36);
  background: black;
  color: white;
  line-height: rem-calc(12.5);
  z-index:1;
  position: absolute;
  top: rem-calc(28);
  right: rem-calc(-45);
  box-shadow: rem-calc(0 4 8 0) $black-20;

  @include respond-to("mobile") {
    top: rem-calc(14);
    right: rem-calc(13);
    height: rem-calc(30);
    padding: rem-calc(9);
  }

  svg {
    fill: white;
    height: rem-calc(14);
    width: rem-calc(14);
    @include respond-to("mobile") {
      height: rem-calc(12);
      width: rem-calc(12);
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/tech-city/map/NewsBitesPanel.vue